export default {"src":"/_next/static/media/minus-icon.f982e709.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};